import type { EtiquetaAutoria, TipoAtorMarco } from '../types/negociacaoMarcoTypes';

export function etiquetaAutoria(tipo: TipoAtorMarco): EtiquetaAutoria {
  switch (tipo) {
    case 'IA':
    case 'SISTEMA':
      return 'Automação';
    case 'USUARIO':
    case 'CONTRAPARTE':
      return 'Atividade humana';
    case 'DESCONHECIDO':
    default:
      return null;
  }
}
